import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilitiesService } from '../../../common/shared/services/utilities.service';
import { Employment } from '../../../common/models/employment';

@Injectable({
  providedIn: 'root'
})
export class EmploymentService {

  constructor(private _httpClient: HttpClient, private _utilitiesService: UtilitiesService) { }

  loadEmployments() {
    return this._httpClient.get(this._utilitiesService.getAPIUrl() + 'Employment', this._utilitiesService.httpConfig);
  }

  deleteEmployment(employmentId: string) {
    return this._httpClient.delete(this._utilitiesService.getAPIUrl() + 'Employment/' + employmentId, this._utilitiesService.httpConfig);
  }

  updateEmployment(employment: Employment) {
    return this._httpClient.patch(this._utilitiesService.getAPIUrl() + 'Employment', employment, this._utilitiesService.httpConfig);
  }

  createEmployment(employment: Employment) {
    return this._httpClient.post(this._utilitiesService.getAPIUrl() + 'Employment', employment, this._utilitiesService.httpConfig);
  }
}
